import './situacao.css';

export type TomSituacao = 'ok' | 'neutro' | 'atencao';

export type SituacaoProps = {
  /** A palavra: "Aberta", "Resolvida", "Online". */
  texto: string;
  /** A cor do ponto. `ok` é verde; `neutro`, cinza; `atencao`, mostarda. */
  tom?: TomSituacao;
};

/**
 * O ponto e a palavra — "● Aberta" — ao lado de um nome.
 *
 * É o mesmo desenho no cabeçalho da conversa e no topo do painel do cliente
 * (v3, #677). Bloco próprio, e não um elemento do `cab-linha`: usado em dois
 * lugares, seria "alcance" de outro bloco num deles.
 *
 * O ponto é `aria-hidden`: a cor é reforço, e a palavra já diz tudo.
 */
export function Situacao({ texto, tom = 'neutro' }: SituacaoProps) {
  return (
    <span className={`situacao situacao--${tom}`}>
      <span className="situacao__ponto" aria-hidden="true" />
      {texto}
    </span>
  );
}
